import { Component } from '@angular/core';

@Component({
  selector: 'mprd-manage-your-account',
  templateUrl: './manage-your-account.component.html',
})
export class ManageYourAccountComponent {
  constructor() {}
}
